var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.isMobile
    ? _c(
        "div",
        {
          staticClass:
            "d-inline-flex text-body-2 link-decoration-underline primary--text cursor-pointer",
          attrs: { "data-qa": "mistake_btn" },
          on: { click: _setup.handleClickMistake },
        },
        [_vm._v("\n  " + _vm._s(_setup.tStatic("Сообщить об ошибке")) + "\n")]
      )
    : _c(
        "div",
        {
          staticClass:
            "d-inline-flex text-body-2 link-decoration-underline primary--text cursor-pointer",
          attrs: {
            "data-qa": "mistake_btn",
            "data-href": _setup.mistakeUrl,
            "data-effect": "mag-popup_anim_vertical",
            "data-open-mistake-form": "",
          },
        },
        [_vm._v("\n  " + _vm._s(_setup.tStatic("Сообщить об ошибке")) + "\n")]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }